import fleetlogicAPI from "helpers/fleetlogicAPI";
import { isFunction, isEmpty, uniq, get } from "lodash";
import Uri from "jsuri";
import { FlaskReq } from "helpers/Request";
import { COMPANY_EMAIL_CONFIG } from "constants/AppConstants";
import * as types from "constants/ActionTypes";
import { authCheck } from "helpers/helper";
import { addMessage } from ".";

export const setReduxData = (data, actionType) => (dispatch, getState) => {
  let obj = {
    type: actionType,
    value: {
      isLoading: false
    }
  };
  switch (actionType) {
    case types.FETCH_TICKETS:
      obj.value.tickets = data;
      break;
    case types.FETCH_TICKETS_MAP:
      obj.value.ticketsMap = data;
      break;
    case types.FETCH_WORKORDERS:
      obj.value.workOrders = data;
      break;
    case types.FETCH_WORKORDERS_MAP:
      obj.value.workOrdersMap = data;
      break;
    case "CONTRACTS":
      obj.value.contracts = data;
    case types.FETCH_CUSTOMERS:
      obj.value.customers = data;
      break;
    case types.FETCH_REQUESTED_PARTS:
      obj.value.requestedParts = data;
      break;
    case types.FETCH_CUSTOMER_SITE:
      obj.value.customerSite = data;
      break;
    case types.FETCH_USERS:
      obj.value.users = data;
      break;
  }
  dispatch(obj);
};

// Get initial data from app's state.
export const getData =
  (requestUrl, actionType, callback, config = {}, refresh = false) =>
  (dispatch, getState) => {
    dispatch({
      type: actionType,
      value: {
        isLoading: true,
        refresh
      }
    });

    return fleetlogicAPI
      .get(requestUrl, config)
      .then(response => {
        let obj = {
          type: actionType,
          value: {
            isLoading: false
          }
        };
        switch (actionType) {
          case "CONTRACTS":
            obj.value.contracts = JSON.parse(response.data);
            break;
          case types.FETCH_WORKORDERS:
            obj.value.workOrders = response.data;
            break;
          case types.FETCH_WORKERS:
            obj.value.workers = response.data;
            break;
          case types.FETCH_WORKERS_MAP:
            obj.value.workersMap = response.data;
            break;
          case types.FETCH_TICKETS:
            obj.value.tickets = response.data;
            break;
          case types.FETCH_PRODUCTS:
            obj.value.products = response.data;
            break;
          case types.FETCH_SITES_FROM_SRM:
            obj.value.customerSitesFromSRM = JSON.parse(response.data);
            break;
          case types.FETCH_STATUS_CODES:
            obj.value.productStatusCodes = response.data;
            break;
          case types.FETCH_MECHANICS:
            obj.value.mechanics = response.data;
            break;
          case types.FETCH_DRIVERS:
            obj.value.drivers = response.data;
            break;
          case types.FETCH_YARD_INSPECTOR:
            obj.value.yardInspectors = response.data;
            break;
          case types.FETCH_PAYMENT_METHODS:
            obj.value.paymentMethods = response.data;
            break;
          case types.FETCH_PART_FROM_FLASK:
            obj.value.partSelected = response.data;
            break;
        }

        if (isFunction(callback)) {
          callback(response.data);
        }
        dispatch(obj);
      })
      .catch(err => {
        switch (actionType) {
          case "CONTRACTS":
            dispatch({
              type: types.FETCH_DATA_ERROR,
              value: {
                isLoading: false,
                contracts: {}
              }
            });
            break;
          case types.FETCH_SITES_FROM_SRM:
            dispatch({
              type: types.FETCH_DATA_ERROR,
              value: {
                isLoading: false,
                customerSitesFromSRM: []
              }
            });
            break;
          default:
            dispatch({
              type: types.FETCH_DATA_ERROR,
              value: {
                isLoading: false
              }
            });
            break;
        }

        if (
          err.response !== undefined &&
          (err.response.status === 401 || err.response.status === 403)
        ) {
          authCheck();
        }
      });
  };

export const getDataFromFlask =
  (params, actionType) => (dispatch, getState) => {
    dispatch({
      type: actionType,
      value: {
        isLoading: true,
        refresh: true
      }
    });
    let obj = {
      type: actionType,
      value: {
        isLoading: false
      }
    };
    return FlaskReq(params).then(res => {
      switch (actionType) {
        case types.FETCH_SITES_FROM_SRM:
          obj.value.customerSitesFromSRM = res.data;
          break;
        case types.FETCH_PAYMENT_METHODS:
          obj.value.paymentMethods = res.data;
          break;
        case types.FETCH_PRODUCTS:
          obj.value.products = res.data;
          break;
        case "CONTRACTS":
          obj.value.contracts = res.data;
          break;
        case types.FETCH_USERS:
          obj.value.users = res.data;
          break;
        case types.FETCH_MECHANICS:
          obj.value.mechanics = res.data;
          break;
        case types.FETCH_DRIVERS:
          obj.value.drivers = res.data;
          break;
        case types.FETCH_SECURITY_ROLES:
          obj.value.securityRoles = res.data;
          break;
        case types.FETCH_MECHANIC_TYPES:
          obj.value.mechanicTypes = res.data;
          break;
        case types.FETCH_STATUS_CODES:
          obj.value.productStatusCodes = res.data;
        case types.FETCH_PRODUCT_CLASS:
          obj.value.productClasses = res.data;
          break;
        case types.FETCH_PRODUCT_GROUP:
          obj.value.productGroups = res.data;
          break;
      }
      dispatch(obj);
    }).catch((error) => {
      console.debug(error)
    })
  };

export const getPrinters = workOrderSelected => (dispatch, getState) => {
  // const mechanic_set = getState().workOrderSelected.workordermechanic_set
  // let operator = mechanic_set.filter(m=> m.is_last_mechanic === true)
  // operator = operator.length > 0 ? operator[0].mechanic : mechanic_set[0].mechanic
  // get printers by dispatcher ID
  let requestUrl = new Uri("misc_settings/printers/").addQueryParam(
    "fl_only",
    "Y"
  );

  return FlaskReq({
      url: `${localStorage.flask_url}/${requestUrl}`,
      method: "get"
    }).then(res => {
    dispatch({
      type: types.FETCH_PRINTERS,
      value: {
        printers: res.data
      }
    });
  });
};

// config email on company level
export const getConfigEmail = () => (dispatch, getState) => {
  return fleetlogicAPI
    .get(`${COMPANY_EMAIL_CONFIG}`)
    .then(res => {
      const CompanyEmail = res.data.results[0];
      dispatch({
        type: types.FETCH_CONFIG_EMAIL,
        value: {
          configEmail: {
            isEmailConfig: true,
            CompanyEmail,
            smtpFromAddress: CompanyEmail.smtp_default_from_address,
            smtpId: CompanyEmail.smtp_id,
            password: CompanyEmail.smtp_password,
            smtpHost: CompanyEmail.smtp_host,
            smtpPort: CompanyEmail.smtp_port,
            smtpEncryptType: CompanyEmail.smtp_encrypt_type
              ? CompanyEmail.smtp_encrypt_type
              : "TLS"
          }
        }
      });
    })
    .catch(err => {
      dispatch(
        addMessage({
          type: "error",
          text: err.data
        })
      );
    });
};

export function setIsLoading(isLoading) {
  return {
    type: types.SET_IS_LOADING,
    payload: isLoading
  };
}
